import { config } from '../config';
import { setSsoSession } from './session';
// Opens the Office Dialog API at our /authdialog page. The dialog performs the
// Cognito Hosted UI OAuth flow and posts the IdToken back via messageParent.
// When `provider` is set, Cognito skips the provider chooser screen and goes
// directly to that federated IdP (mirrors dealroom-fe's oauthSignIn flow).
export function loginWithSso(opts = {}) {
    const params = new URLSearchParams();
    if (opts.provider)
        params.set('provider', opts.provider);
    if (opts.loginHint)
        params.set('hint', opts.loginHint);
    const url = `${config.addinOrigin}/authdialog.html${params.toString() ? `?${params}` : ''}`;
    return new Promise((resolve, reject) => {
        Office.context.ui.displayDialogAsync(url, { height: 60, width: 40, promptBeforeOpen: false }, (asyncResult) => {
            if (asyncResult.status === Office.AsyncResultStatus.Failed) {
                return reject(new Error(asyncResult.error.message));
            }
            const dialog = asyncResult.value;
            dialog.addEventHandler(Office.EventType.DialogMessageReceived, (arg) => {
                try {
                    const payload = JSON.parse(arg.message);
                    if (payload.error)
                        throw new Error(payload.error);
                    if (!payload.idToken)
                        throw new Error('No idToken in dialog response');
                    setSsoSession(payload.idToken, payload.expiresIn ?? 3600);
                    dialog.close();
                    resolve();
                }
                catch (e) {
                    dialog.close();
                    reject(e);
                }
            });
            dialog.addEventHandler(Office.EventType.DialogEventReceived, () => reject(new Error('Dialog closed')));
        });
    });
}
